import React from 'react';
import memoize from 'memoize-one';
import { BasicDropdown, Icon } from '../../components';

const massiveActions = memoize((handleClick, permissions, disabled) => {
  const actions = () => {
    const authorizedActions = [];

    if (permissions.destroy) {
      authorizedActions.push({
        icon: <Icon icon="trash" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'destroy',
        props: {
          onClick: () => handleClick('massive_destroy'),
          disabled
        },
        title: 'Eliminar'
      });
    }
    if (permissions.update) {
      authorizedActions.push({
        icon: <Icon icon="checkmark-circle" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'massive_active',
        props: {
          onClick: () => handleClick('massive_active'),
          disabled
        },
        title: 'Activar'
      });
    }
    if (permissions.update) {
      authorizedActions.push({
        icon: <Icon icon="close-circle" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'massive_deactivate',
        props: {
          onClick: () => handleClick('massive_deactivate'),
          disabled
        },
        title: 'Desactivar'
      });
    }
    return authorizedActions;
  };

  return (
    <div className="mb-4">
      <BasicDropdown
        block
        items={actions()}
        noArrow
        right
        titleDrop={
          <span className="align-middle">
            Acciones Masivas <Icon icon="ellipsis-vertical" height="20px" width="20px" />
          </span>
        }
        variant="outline-primary"
      />
    </div>
  );
});

export default massiveActions;
